// Today / SDR experience rollout gate.
//
// ui_persona='sdr' is a per-member setting (Workspace Members > Experience).
// When enabled, members see the Today dashboard,
// and related SDR UX. Production honors the setting for every workspace —
// no vendor or pilot allowlist.
//
// Single source of truth: DashboardMain.tsx, ProtectedLayout Menu, and
// TasksHub must all call isSdrExperienceRolledOut — never duplicate gating.

export function isSdrExperienceRolledOut(
  isSdr: boolean | undefined,
  _vendorid?: number,
  _userId?: string | null,
): boolean {
  return isSdr === true;
}

/**
 * Whether this user's own Today carries the sequence follow-up queue: Admin Today on a
 * GTM-signal workspace, or SDR Today — the dashboards DashboardMain renders for them.
 * Actions keeps its Follow Up tab for everyone else (AEs, members without the SDR
 * experience), so moving the queue to Today never leaves anyone without it.
 */
export function ownTodayHasSequenceFollowups({ isAdmin, isSdr, gtmSignalEnabled, vendorid, userId }: {
  isAdmin: boolean | undefined;
  isSdr: boolean | undefined;
  gtmSignalEnabled: boolean | undefined;
  vendorid?: number;
  userId?: string | null;
}): boolean {
  if (isAdmin === true) return gtmSignalEnabled === true;
  return isSdrExperienceRolledOut(isSdr, vendorid, userId);
}
